// import React from 'react';
// import styles from './ObservationCard.module.css';
// import PersonIcon from "@material-ui/icons/Person";
// import { MdOutlineDateRange } from 'react-icons/md';


// const ObservationCard = ({ chargeMovements = [], cycleMovements = [], modal }) => {
//   const allMovements = [...chargeMovements, ...cycleMovements];

//   // función para separar comentario, usuario y fecha
//   const parseMovement = (movement) => {
//     const [commentPart, userDatePart] = movement.split(" - (");
//     const userDateClean = userDatePart?.replace(")", "") ?? "";
//     const [user, date] = userDateClean.split(" - ");
//     return {
//       comment: commentPart,
//       user: user?.trim(),
//       date: date?.trim(),
//     };
//   };

//   return (
//     <div>
//       <label className={styles.label}>
//         Observations
//       </label>
//       <div className={modal ? styles.containerModal : styles.containerDetail}>
//         {allMovements.length > 0 ? (
//           allMovements.map((movement, index) => {
//             const { comment, user, date } = parseMovement(movement);
//             return (
//               <div key={index} className={styles.card}>
//                 <p className={styles.observation}>{comment}</p>
//                 <div className={styles.footer}>
//                   <PersonIcon className={styles.icon} />
//                   <span className={styles.text}>{user}</span>
//                   <span className={styles.separator}>|</span>
//                   <MdOutlineDateRange className={styles.icon} />
//                   <span className={styles.text}>{date}</span>
//                 </div>
//               </div>
//             );
//           })
//         ) : (
//           <p className={styles.observation}>No observations available.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ObservationCard;

import React from 'react';
import { motion, AnimatePresence } from "framer-motion";
import styles from "./ObservationCard.module.css";
import TextAreaQ from '../FormComponents/TextAreaQ/TextAreaQ';
import moment from "moment";
import { getRegionalFormat } from "../../utils/sessionHandler";
import parseFormatDate from "../../utils/parseFormatDate";
import t from "../../utils/translation";

const ObservationCard = ({
  chargeMovements = [],
  cycleMovements = [],
  movementsObservations = [],
  modal = false,
  handleChange,
  name,
  value,
  washing = false,
  pkg = false,
}) => {
  const processMovements = (movementsArray) =>
  movementsArray.map((movement, index) => {
    
    let commentPart = "";
    let userDatePart = "";

    if (movement.includes(" - (")) {
      [commentPart, userDatePart] = movement.split(" - (");
    } else if (movement.includes("(")) {
      
      const parts = movement.split("(");
      commentPart = parts[0];
      userDatePart = parts.slice(1).join("("); 
    } else {
     
      commentPart = movement;
      userDatePart = "";
    }

    commentPart = commentPart.trim();
    userDatePart = userDatePart.replace(")", "").trim();

    let user = "";
    let dateStrRaw = "";

    if (userDatePart.includes(" - ")) {
      [user, dateStrRaw] = userDatePart.split(" - ");
    } else {
      user = userDatePart;
      dateStrRaw = "";
    }

    user = user?.trim() || "";
    dateStrRaw = dateStrRaw?.trim() || "";

    const date = dateStrRaw
      ? moment.utc(dateStrRaw).local()
      : null;

    const formattedDate = date
      ? date.format(`${parseFormatDate(getRegionalFormat().dateFormat)} ${getRegionalFormat().timeFormat}`)
      : "";

    return {
      id: index,
      text: commentPart,
      user: user,
      date: formattedDate,
    };
  });

  let allMovements = [...chargeMovements, ...cycleMovements];
  
  if (pkg) {
    allMovements = [...allMovements, ...movementsObservations];
  }

  allMovements = processMovements(allMovements);

  // Eliminar duplicados por texto + usuario
  const seen = new Set();
  allMovements = allMovements.filter((item) => {
    const key = `${item.text}__${item.user}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  const getInitials = (name) => {
    return name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  return (
    <div>
      {(chargeMovements.length > 0 || cycleMovements.length > 0 || (pkg && movementsObservations.length > 0)) && (
        <label className={styles.label}>{t("ObservationSpan")}</label>
      )}

      <div className={styles.timelineContainer}>
        <div className={styles.timeline}>
          <AnimatePresence>
            {allMovements.map((cmt) => (
              <motion.div
                key={`${cmt.text}-${cmt.user}-${cmt.date}`}
                className={styles.timelineItem}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10, scale: 0.9 }}
                transition={{ duration: 0.3 }}
              >
               <div className={washing ? styles.timelineIconWashing : styles.timelineIcon}>
                {cmt.user ? getInitials(cmt.user) : "?"}
              </div>
                <div className={styles.timelineContent}>
                  <div className={styles.commentTop}>
                    <span className={styles.commentUser}>{cmt.user}</span>
                    <span className={styles.commentDate}>{cmt.date}</span>
                  </div>
                  <div className={styles.commentText}>{cmt.text}</div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>

      {modal && (
        <div className={styles.addObservationSection}>
          <TextAreaQ
            width="100%"
            label="New observations"
            name={name}
            handleChange={handleChange}
            value={value}
            labelTop={true}
          />
        </div>
      )}
    </div>
  );
};

export default ObservationCard;